export default function (Vue, options) {
    Vue.directive('dyKeyboard', {
        bind(el, binding, vnode) {
            el.onfocus = function (e) {
                console.log(e);
                for (let i = 0; i < vnode.context.$root.$children.length; i++) {
                    if (vnode.context.$root.$children[i].$refs[options.ref || 'dyKeyboard']) {
                        let timer = setTimeout(() => {
                            // 延迟是为了获取焦点
                            clearTimeout(timer);
                            timer = null;
                            let option = {
                                el: el, // 当前元素
                                blurIndexStart: e.srcElement.selectionStart, // 初始化开始焦点
                                blurIndexEnd: e.srcElement.selectionEnd // 初始化结束焦点
                            };
                            vnode.context.$root.$children[i].$refs[options.ref || 'dyKeyboard'].show(el.value, option);
                        }, 0);
                        break;
                    }
                }
            };
        }
    });
}
